import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ClearVisionForMarbleFalls from "./sections/ClearVisionForMarbleFalls";
import OurPhilosophy from "./sections/OurPhilosophy";
import SpecializedCareWings from "./sections/SpecializedCareWings";
import WhyChooseSmileCraft from "./sections/WhyChooseSmileCraft";
import PatientSuccessStories from "./sections/PatientSuccessStories";
import SecureYourVisit from "./sections/SecureYourVisit";
import AccessAndInstallation from "./sections/AccessAndInstallation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ClearVisionForMarbleFalls />
      <OurPhilosophy />
      <SpecializedCareWings />
      <WhyChooseSmileCraft />
      <PatientSuccessStories />
      <SecureYourVisit />
      <AccessAndInstallation />
      <Footer />
    </div>;
}